import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { PromotionFormPageRoutingModule } from './promotion-form-routing.module';

import { PromotionFormPage } from './promotion-form.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    PromotionFormPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [PromotionFormPage]
})
export class PromotionFormPageModule {}
